import clsx from 'clsx'
import update from 'immutability-helper'
import moment from 'moment'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Typography from '@mui/material/Typography'
import {WhiteButton, BlueButton} from './buttons'
import {EditIcon, TrashIcon} from '../../../../resources/icons'
import {faStickyNote} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {createPost} from '../../../../helpers/command'
import EditComment from './edit-comment'


const useStyles = makeStyles(commentStyles)

export default function Comment (props) {

  const {comment, index, context} = props
  const {translate, settings, languageId} = context
  const classes = useStyles()
  const [editing, setEditing] = React.useState(false)
  const [originalComment] = React.useState(comment.comment)
  const date = moment(comment.added).format(translate('assessment-sent-on-format'))

  function handleCommentChange(e) {
    context.updateState({quizAssessmentToReview: {
      properties: {
        comments: {
          [index]: {comment: {$set: e.target.value}}
        }
      }
    }})
  }

  function handleCommentCancel() {
    context.updateState({quizAssessmentToReview: {
      properties: {
        comments: {
          [index]: {comment: {$set: originalComment}}
        }
      }
    }})
    setEditing(false)
  }

  async function handleCommentSave() {
    if (comment.comment.length > 0) {
      const {quizAssessmentToReview: assessment} = context
      const {id, properties} = assessment
      createPost('quiz','saveReviewProperties')({id, properties})
      setEditing(false)
    }
  }

  return (
    <React.Fragment>
      {/* <Fade in={editing}> */}
        <Box className={classes.editComment} style={{display: editing ? 'flex' : 'none'}}>
          {editing && <EditComment
            onChange={handleCommentChange}
            onCancel={handleCommentCancel}
            onSave={handleCommentSave}
            {...{...comment, context}}
          />}
        </Box>
      {/* </Fade> */}
      {/* <Fade in={!editing}> */}
        <Box className={classes.root} style={{display: editing ? 'none' : 'flex'}}>
            <Box className={classes.date}>
              <span className={clsx(classes.middle, "icon")}><FontAwesomeIcon icon={faStickyNote} /></span>
              <span className={`${classes.middle} ${classes.dateLabel}`}>{date}</span>
              <span className={`${classes.middle} ${classes.edit}`} onClick={() => setEditing(true)}>
                <EditIcon />
              </span>
              <span className={`${classes.middle} ${classes.delete}`} onClick={() => props.onDeleteComment(comment)}>
                <TrashIcon />
              </span>
            </Box>
            <Box className={classes.comment}>
              <textarea readOnly value={comment.comment} />
            </Box>
        </Box>
      {/* </Fade> */}
    </React.Fragment>
  )
}

function commentStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      border: 'solid 1px #c2c7ca',
      borderRadius: '4px',
      padding: '20px',
      [theme.breakpoints.down('sm')]: {
        padding: '10px'
      }
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      "&.icon": {
        marginTop: -3,
        fontSize: '12pt',
        color: '#647f90'
      }
    },
    date: {
      display: 'flex',
      flexShrink: 0,
      color: '#647f90',
      fontSize: '12pt',
    },
    dateLabel: {
      flexGrow: 1,
      marginLeft: '10px',
      paddingTop: '2px'
    },
    edit: {
      marginRight: '15px',
      cursor: 'pointer',
      '&:hover': {
        transform: 'scale(1.1)'
      }
    },
    delete: {
      cursor: 'pointer',
      '&:hover': {
        transform: 'scale(1.1)'
      }
    },
    editComment: {
      display: 'flex',
      flexGrow: 1
    },
    comment: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: '100px',
      marginTop: '10px',
      '& > textarea': {
        resize: 'none',
        flexGrow: 1,
        borderRadius: '4px',
        border: 'solid 1px #c2c7ca',
      }
    },
    save: {
      width: '120px'
    },
    cancel: {
      width: '120px',
      marginRight: '30px',
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
      }
    }
  };
}

